import { IEventBus } from "../typings/event-bus";
import { IScrollLock } from "../typings/modal-scrollLock";
import { EventBus } from "./event-bus";
import { ScrollLock } from "./modal-scrollLock";

export class ModalDialog {
    private readonly scopes: NodeListOf<HTMLElement>;
    private readonly scrollLock: IScrollLock;
    private readonly eventBus: IEventBus;
    private static _instance: ModalDialog;

    private constructor() {
        this.scopes = document.querySelectorAll('.scope-dlp') as NodeListOf<HTMLElement>;
        this.scrollLock = ScrollLock.instance;
        this.eventBus = EventBus.instance;

        if(!this.scopes) {
            return;
        }
        
        this.initModalDialogComponent();
    }

    static get instance() {
        return this._instance || (this._instance = new this());
    }
    
    private initModalDialogComponent() : void {
        const scopesArray: Array<HTMLElement> = Array.prototype.slice.call(this.scopes);

        for (const scope of scopesArray)
        {
            const dlpToggleModals: NodeListOf<HTMLElement> = scope.querySelectorAll('.dlp-toggle-modal') as NodeListOf<HTMLElement>;
            const dlpToggleModalsArray: Array<HTMLElement> = Array.prototype.slice.call(dlpToggleModals);

            for (const dlpToggleModal of dlpToggleModalsArray) {
                dlpToggleModal.addEventListener('click',() => { this.openCloseModal(dlpToggleModal, scope); });
            }
        }
    }
    
    private openCloseModal(dlpToggleModal: HTMLElement, scope: HTMLElement): void {
        const modalId: String = this.readModalId(dlpToggleModal);

        if (this.isVideoModalInMobileShop(dlpToggleModal)) {
            return;
        }

        if (!modalId) {
            return;
        }
        
        const modalElements: NodeListOf<HTMLElement> = scope.querySelectorAll('[data-dlp-modalid="' + modalId + '"]') as NodeListOf<HTMLElement>;
        const modalElementsArray: Array<HTMLElement> = Array.prototype.slice.call(modalElements);
        let modalDialog: HTMLElement;
        let modalDialogParent: HTMLElement;
        
        for (const modalElement of modalElementsArray) {
            if (modalElement.classList.contains('dlp-modalDialog')){
                modalDialog = modalElement;
            }
            else {
                modalDialogParent = modalElement;
            }
        } 
        
        if (!modalDialog || !modalDialogParent) {
            return;
        }

        if (modalDialog.classList.contains('dlp-show-modal')) {
            this.close(modalDialog, modalDialogParent);
        } else {
            this.open(modalDialog, scope);
        }
    }

    private readModalId(dlpToggleModal: HTMLElement): string {
        const guidContainer: HTMLElement = dlpToggleModal.closest('[data-dlp-modalid]') as HTMLElement;
        
        if (!guidContainer) {
            return undefined;
        }

        return guidContainer.getAttribute('data-dlp-modalid');
    }

    private open(overlay: HTMLElement, scope: HTMLElement): void {
        scope.appendChild(overlay);
        this.scrollTextToTop(overlay);

        overlay.classList.add('dlp-show-modal');
        this.scrollLock.lock();

        this.eventBus.publish("VideoPlay", overlay);
    }

    private close(overlay: HTMLElement, modalDialog: HTMLElement): void {
        overlay.classList.remove('dlp-show-modal');
        this.scrollLock.unlock();

        this.eventBus.publish("VideoStop", overlay);

        modalDialog.appendChild(overlay);
    }

    private scrollTextToTop(overlay: HTMLElement): void {
        const textScrollContainer: HTMLElement = overlay.querySelector('.text-scrollbar-container') as HTMLElement;
        
        if (textScrollContainer) {
            // works on ie nad other browsers:
            textScrollContainer.scrollTop = 0;
        }
    }

    private isVideoModalInMobileShop(element: HTMLElement): boolean {
        const isVideo: boolean = (<HTMLElement>element).classList.contains('dlp-video-link');
        const isInMobileShop: boolean = document.documentElement.classList.contains('mobileshop');

        return isVideo && isInMobileShop;
    }
}

ModalDialog.instance;